import { Tag } from './tag.model';
import { Instructor } from './instructor.model';

export class Course{
    title: string;
    shortDescription: string;
    longDescription: string;
    courseNumber: number;
    tags: Array<Tag> = [];
    required: boolean;
    credits: number;
    key: boolean;
    relevancy: number = 0;
    listingImage: string;
    headerImage: string;
    instructors: Array<Instructor> = [];
    prerequisites: Array<Course> = [];
    recommended: Array<Course> = [];
    prereqText: string;
    faculty: string;
    id: number;
    courseOpen: boolean = false;
    gallery: Array<string> = [];
}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/models/course.model.ts